import { getCategories } from "../category"

// TODO can be grouped together with filter-checkboxes?
export function updateFilterCategoryCheckboxes(categories: string[]) {
    resetCategoryCheckboxes()

    for (const category of categories) {
        const checkbox = getCategoryCheckboxInDom(category)
        if (checkbox) {
            checkbox.checked = true
        } else {
            console.warn("Checkbox not found while updating Category in Dom", category)
        }
    }
}

export function getCategoryCheckboxInDom(value: string) {
    return document.querySelector<HTMLInputElement>(`input[data-seo-group="rubrik"][data-seo="${value}"]`)
}

export function resetCategoryCheckboxes() {
    const elements = Array.from(
        document.querySelectorAll<HTMLInputElement>(".filter-rubrik-row .custom-checkbox input"),
    )
    for (const element of elements) {
        element.checked = false
    }
}

updateFilterCategoryCheckboxes(getCategories())
